import { useAuth } from "contexts/AuthContext";
import ProfilePictureManager from "./ProfilePictureManager";

export default function ProfileCard() {
    const { user } = useAuth();

    return (
        <div className="col-md-4">
            <div className="card mb-4">
                <div className="card-body text-center">
                    <ProfilePictureManager />
                    <h5 className="card-title">{user?.firstName} {user?.lastName}</h5>
                    <p className="text-muted">{user?.email}</p>
                </div>
            </div>
        </div>
    );
}
